/*
 *     Copyright (c) 2020 Bcame S.r.l.. All rights reserved.
 *     Bcame S.r.l. Technology Business Unit
 *
 *     Company confidential.
 *
 *     This software is proprietary  to and embodies the confidential
 *     technology of Bcame S.r.l..  Possession, use, or copying of this
 *     software and media is authorized only pursuant to a valid written
 *     license from Bcame S.r.l.  or an authorized sublicensor.
 *
 *     Bcame S.r.l.
 */
export default {
  enabledLanguages: [
    {
      label: 'Italiano',
      value: 'it_it',
      currency: '€',
      currencyKey: 'EUR'
    },
    {
      label: 'English',
      value: 'it_en',
      currency: '$',
      currencyKey: 'USD'
    },
    {
      label: 'English',
      value: 'en_GB',
      currency: '£',
      currencyKey: 'GBP'
    }
  ],
  customAttributes: {
    category: {
      lookCategory: 'bc_cat_type_name'
    }
  },
  cookiebot: {
    is_active: Boolean(process.env.VUE_APP_COOKIEBOT_GROUP_ID),
    group_id: process.env.VUE_APP_COOKIEBOT_GROUP_ID
  },
  shynistat: {
    is_active: process.env.VUE_APP_SHYNISTAT_ENABLE
  },
  equalweb: {
    is_active: false
  },
  API: {
    locale: 'rest/{{storeViewCode}}/V1/label/translation/{{storeViewCode}}',
    elasticsearch: {
      httpAuth: '',
      host: `${process.env.VUE_APP_BASE_PATH}/api/catalog`,
      index: 'vue_storefront_catalog'
    },
    swatchPath: `${process.env.VUE_APP_MAGENTO}/media/attribute/swatch`,
    newsletter: {
      subscribeCustomer: `/rest/{{storeViewCode}}/V1/newsletterExt`
    },
    catalog: {
      categories: '/rest/{{storeViewCode}}/V1/categories/list?searchCriteria',
      listing: '/rest/{{storeViewCode}}/V1/products',
      // product: '/api/products/{{storeViewCode}}?token={{token}}&sku={{sku}}'
      product: 'rest/{{storeViewCode}}/V1/products/{{sku}}',
      notifyMe: 'rest/V1/guest-product-alert/stocks'
    },
    graphql: `graphql`,
    img: {
      entryPoint: `${process.env.VUE_APP_MAGENTO}/pub/media/catalog/product/cache/b4e5230bef153e836a55d3dcec0fad4a`,
      entryPointIcon: `${process.env.VUE_APP_MAGENTO}/pub/media/catalog/product/cache/b4e5230bef153e836a55d3dcec0fad4a`,
      entryPointXS: `${process.env.VUE_APP_MAGENTO}/pub/media/catalog/product/cache/b4e5230bef153e836a55d3dcec0fad4a`,
      entryPointSM: `${process.env.VUE_APP_MAGENTO}/pub/media/catalog/product/cache/b4e5230bef153e836a55d3dcec0fad4a`,
      entryPointMD: `${process.env.VUE_APP_MAGENTO}/pub/media/catalog/product/cache/b4e5230bef153e836a55d3dcec0fad4a`,
      entryPointLD: `${process.env.VUE_APP_MAGENTO}/pub/media/catalog/product/cache/b4e5230bef153e836a55d3dcec0fad4a  `,
      placeholder: require('@/assets/image/placeholder.jpg'),
      resizeUrl: `${process.env.VUE_APP_SERVER}/img`
    },
    users: {
      me: `rest/{{storeViewCode}}/V1/customers/me`,
      login: `/rest/{{storeViewCode}}/V1/integration/customer/token`,
      create: `rest/{{storeViewCode}}/V1/customers`,
      resetPassword: `rest/{{storeViewCode}}/V1/customers/password`,
      resetPasswordFinalStep: `rest/{{storeViewCode}}/V1/customers/resetPassword`,
      emailAvailable: '/rest/{{storeViewCode}}/V1/customers/isEmailAvailable'
    },
    order: {
      list: '/orders',
      single: '/orders/{{orderId}}',
      shipments: '/shipments/{{orderId}}',
      reserve: `/api/orders/{{storeViewCode}}/reserve`,
      restoreQuote: `/api/orders/{{storeViewCode}}/restoreQuote`,
      reorder: `rest/{{storeViewCode}}/V1/api/cart/fillCartFromOrder?orderId={{orderId}}`
    },
    cart: {
      create: `/rest/{{storeViewCode}}/V1/carts/mine`,
      createGuest: `/rest/{{storeViewCode}}/V1/guest-carts`,
      items: `/rest/{{storeViewCode}}/V1/carts/mine/items`,
      itemsGuest: `/rest/{{storeViewCode}}/V1/guest-carts/{{cartId}}/items`,
      pull: `${process.env.VUE_APP_BASE_PATH}/api/carts/pull?token={{token}}&cartId={{cartId}}`,
      stock: `${process.env.VUE_APP_BASE_PATH}/api/stock/check?sku={{sku}}`,
      add: `/rest/{{storeViewCode}}/V1/carts/mine/items`,
      addGuest: `/rest/{{storeViewCode}}/V1/guest-carts/{{cartId}}/items`,
      update: `/rest/{{storeViewCode}}/V1/carts/mine/items/{{itemId}}`,
      updateGuest: `/rest/{{storeViewCode}}/V1/guest-carts/{{cartId}}/items/{{itemId}}`,
      addCoupon: `/api/carts/{{storeViewCode}}/addCoupon?token={{token}}&cartId={{cartId}}&couponCode={{couponCode}}`,
      deleteCoupon: `/api/carts/{{storeViewCode}}/deleteCoupon?token={{token}}&cartId={{cartId}}&couponCode={{couponCode}}`,
      delete: `/rest/{{storeViewCode}}/V1/carts/mine/items/{{itemId}}`,
      deleteGuest: `/rest/{{storeViewCode}}/V1/guest-carts/{{cartId}}/items/{{itemId}}`,
      totals: `/rest/{{storeViewCode}}/V1/carts/mine/totals`,
      totalsGuest: `/rest/{{storeViewCode}}/V1/guest-carts/{{cartId}}/totals`,
      giftCard: `/rest/{{storeViewCode}}/V1/carts/{{cartId}}/aw-giftcard/{{giftCardCode}}`,
      giftCardGuest: `/rest/{{storeViewCode}}/V1/guest-carts/{{cartId}}/aw-giftcard/{{giftCardCode}}`,
      switchGuestToLoggin: `/rest/{{storeViewCode}}/V1/guest-carts/{{cartId}}`,
      shippingInfo: `/rest/{{storeViewCode}}/V1/carts/mine/shipping-information`,
      shippingInfoGuest: `/rest/{{storeViewCode}}/V1/guest-carts/{{cartId}}/shipping-information`,
      shippingMethods: `/rest/{{storeViewCode}}/V1/carts/mine/shipping-methods`,
      shippingMethodsGuest: `/rest/{{storeViewCode}}/V1/guest-carts/{{cartId}}/shipping-methods`,
      paymentMethods: `/rest/{{storeViewCode}}/V1/carts/mine/payment-methods`,
      paymentMethodsGuest: `/rest/{{storeViewCode}}/V1/guest-carts/{{cartId}}/payment-methods`,
      placeOrder: `/rest/{{storeViewCode}}/V1/carts/mine/order`,
      placeOrderGuest: `/rest/{{storeViewCode}}/V1/guest-carts/{{cartId}}/order`,
      paymentInformation: `/rest/{{storeViewCode}}/V1/carts/mine/payment-information`,
      paymentInformationGuest: `/rest/{{storeViewCode}}/V1/guest-carts/{{cartId}}/payment-information`
    },
    storeLocator: {
      allBoutiques: `/rest/V1/mwlocations`,
      singleBoutique: `/rest/V1/mwlocations/{{code}}`,
      productOnStore: `/extend_mw/location/updatefindastore` // IS A POST (product: productId)
    },
    countries: {
      allCountries: `/geolocator/system/table`
    },
    payments: {
      adyen: {
        imgPath: 'https://checkoutshopper-test.adyen.com/checkoutshopper/images/logos/{{type}}.svg'
      },
      satispay: {
        buttonjs: `${process.env.VUE_APP_SATISPAY}/web-button.min.js`,
        postPaymentId: `/rest/{{storeViewCode}}/V1/ext/satispay/payments`, // BUS da integrare
        getPaymentInfo: '/rest/{{storeViewCode}}/V1/ext/satispay/payments?satispayId={{satispayId}}'
      },
      unicredit: {
        getRedirect: `/rest/{{storeViewCode}}/V1/ext/pagonline/payment/{{orderId}}`, // BUS da integrare
        verify: '/rest/{{storeViewCode}}/V1/ext/pagonline/payment/verify' // BUS da integrare
      },
      paypal: {
        url: 'https://www.paypalobjects.com/api/checkout.js',
        isProduction: process.prod,
        getToken_endpoint: '/rest/{{storeViewCode}}/V1/ext/paypal/create-token?token={{token}}' // BUS da integrare
      }
    },
    rma: {
      attachment: '/returns/attachment/upload'
    },
    common: {
      countries: `/rest/{{storeViewCode}}/V1/directory/countries`
    },
    cms: {
      page: `/rest/{{storeViewCode}}/V1/snowdog/cmsPageIdentifier/{{indentifier}}/storeId/{{storeviewID}}`,
      pageId: `/rest/{{storeViewCode}}/V1/snowdog/cmsPage/{{pageID}}`,
      content: `/rest/{{storeViewCode}}/V1/snowdog/cmsBlockIdentifier/{{indentifier}}/storeId/{{storeviewID}}`,
      styleLib: '', // `${process.env.VUE_APP_CMS}/wp-includes/css/dist/block-library/style.min.css`,
      globalIDs: []
    },
    giftCard: {
      customerGiftCards: `/rest/{{storeViewCode}}/V1/awGiftcard/get-giftcards-by-customer`,
      checkStatus: `/rest/{{storeViewCode}}/V1/awGiftcard/{{giftcardCode}}`
    },
    customerService: `/contactusapi/attachment/upload`
  },
  Theme: {
    name: 'Bcommerce',
    isHeroString: 'is-hero-cms',
    storeviewRegex: '[a-z0-9]{2,4}_[a-z]{2}',
    priceIncludeTax: true,
    enableRoute: true,
    enablei18n: true,
    facebookAppId: '775332086567336',
    selectedOptionsIDs: {
      // map id of attribute view vue-storefront/src/theme/components/Product/ProductSelectedOptions.vue for more info
      140: 'SizeSelected'
    },
    gridCol: 3,
    listingColumns: 3,
    rootCategoryID: 2,
    miniCartClosingTime: 8000, // milliseconds
    maxSelectionQty: 30,
    blockTaxRuleID: 'vat_information',
    sizeCountries: [
      { value: 'IT' },
      { value: 'EU' },
      { value: 'UK' },
      { value: 'US' },
      { value: 'AU' },
      { value: 'JP' }
    ],
    defaultCountry: {
      'IT': 'IT',
      'GB': 'UK',
      'UK': 'UK',
      'AU': 'AU',
      'US': 'US',
      'EU': 'EU',
      'HR': 'EU',
      'JP': 'JP',
      'HK': 'JP',
      'CA': 'US'
    },
    widthMobile: 1025,
    gridEnable: [
      { value: 1, text: '1' },
      { value: 3, text: '3' },
      { value: 6, text: '6' }
    ],
    listingFilters: {
      columnsView: {
        selected: 2,
        options: [
          {
            label: '2 columns',
            value: 2
          },
          {
            label: '4 columns',
            value: 4
          }
        ]
      },
      productMode: {
        selected: 'model-view',
        options: [
          {
            label: 'product-view',
            value: 'product-view'
          },
          {
            label: 'model-view',
            value: 'model-view'
          }
        ]
      }
    },
    defaultOpt: {
      imageCrop: {
        width: 500,
        height: 670,
        quality: 80
      }
    },
    listingOpt: {
      imageCrop: {
        width: 800,
        height: 1072,
        quality: 80
      }
    },
    productOpt: {
      imageCrop: {
        crop: true,
        width: 800,
        height: 800,
        quality: 100
      }
    },
    sort: 'position',
    sortOrientation: 'ASC',
    sortOrientationNegate: 'DESC',
    paginationSize: 32,
    defaultFilters: [
      {
        code: 'color',
        term: 'color_options'
      },
      {
        code: 'size',
        term: 'size_options'
      },
      {
        code: 'price',
        term: 'price'
      }
    ],
    default: {
      shippingMethod: 'flatrate',
      shippingMethods: [
        {
          method_code: 'flatrate',
          method_title: 'flatrate'
        }
      ],
      country: 'IT',
      blogRoute: 'inspirations'
    },
    externalCheckout: `${process.env.VUE_APP_MAGENTO}/{{storeViewCode}}/vue/cart/sync/token/{{token}}/cart/{{cartId}}`,
    paypalExpress: {
      externalCheckout: `${process.env.VUE_APP_MAGENTO}/{{storeViewCode}}/vue/paypal/sync/token/{{token}}/cart/{{cartId}}`
      /* url: 'https://www.paypalobjects.com/api/checkout.js',
      isProduction: process.prod,
      getToken: `${process.env.VUE_APP_MAGENTO}/paypal/express/getTokenData`,
      onAuthorizeUrl: `${process.env.VUE_APP_MAGENTO}/paypal/express/onAuthorization/`,
      style: {
        layout: 'horizontal',
        size: 'responsive',
        color: 'white',
        shape: 'rect',
        label: 'paypal'
      } */
    },
    amazon: {
      disableInStore: ['us_en'],
      options: {
        buttonType: 'PwA',
        buttonColor: 'LightGray',
        buttonSize: 'large',
        scope: 'profile payments:widget payments:shipping_address payments:billing_address',
        popup: true
      },
      redirectUrl: `${process.env.VUE_APP_MAGENTO}/{{storeViewCode}}/vue/amazon/sync/token/{{token}}/cart/{{cartId}}/access_token/`,
      scriptWidget: 'https://static-eu.payments-amazon.com/OffAmazonPayments/{country}/{isSandbox}lpa/js/Widgets.js?nomin',
      scriptWidgetUS: 'https://static-na.payments-amazon.com/OffAmazonPayments/{country}/{isSandbox}js/Widgets.js?nomin',
      scriptWidgetJP: 'https://static-fe.payments-amazon.com/OffAmazonPayments/{country}/{isSandbox}lpa/js/Widgets.js?nomin'
    },
    giftCardPluginCode: 'aw_giftcard',
    forms: {
      prefixValues: ['Mr', 'Mrs']
    },
    searchSuggestions: {
      categoryLimit: 4,
      productLimit: 5
    },
    liveChat: {
      id: 'ab7c84e901fa36bb00589f49853ede84',
      url: '//live.chat-assistant.net/script.php?id=ab7c84e901fa36bb00589f49853ede84'
    },
    attributesToload: [
      'description',
      'washing1',
      'washing2',
      'washing3',
      'washing4',
      'washing5',
      'washing6',
      'fitting_filter',
      'fitting',
      'technical_composition'
    ],
    wishlistAttributesToload: [],
    contactUs: {
      // options - map label in translate file
      reason: [
        // Informazione sui prodotti
        { value: 'info', to: process.env.VUE_APP_EMAIL },
        // Acquisti Online - Informazioni sul mio acquisto
        { value: 'buy-info-0', mandatory: ['orderid'], to: process.env.VUE_APP_EMAIL_CARE, cc: process.env.VUE_APP_EMAIL },
        // Acquisti Online - Spedizione
        { value: 'buy-info-1', mandatory: ['orderid'], to: process.env.VUE_APP_EMAIL_CARE, cc: process.env.VUE_APP_EMAIL },
        // Acquisti Online - Assistenza all'acquisto / Difficoltà tecniche
        { value: 'buy-info-2', mandatory: ['orderid'], to: process.env.VUE_APP_EMAIL_CARE, cc: process.env.VUE_APP_EMAIL },
        // Acquisti Online - Resi e Rimborsi
        { value: 'buy-info-3', mandatory: ['orderid'], to: process.env.VUE_APP_EMAIL_CARE, cc: process.env.VUE_APP_EMAIL },
        // Acquisti nei Negozi - Informazioni / Reclami
        { value: 'buy-store', to: process.env.VUE_APP_EMAIL },
        // Dove trovare i nostri negozi
        { value: 'find-store', to: process.env.VUE_APP_EMAIL },
        // Opportunità di lavoro
        { value: 'work-opportunity', to: process.env.VUE_APP_EMAIL_UMAN },
        // Proposte commerciali
        { value: 'commercial-proposal', to: process.env.VUE_APP_EMAIL },
        // Press
        { value: 'press', to: process.env.VUE_APP_EMAIL_PRESS },
        // Wholesale
        { value: 'wholwsale', to: process.env.VUE_APP_EMAIL },
        // Suggerimenti di stile
        { value: 'suggestions', to: process.env.VUE_APP_EMAIL_SUGGESTION }
      ]
    }
  }, // end Theme
  map: {
    zoom: 7
  }
}
